import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { T } from '../../traks';

export const PremiumHeader = () => {
    return (
        <Row className="premium-banner premium-banner-container pt-5">
            <Container>
            <Col>
                <Row>
                    <Col sm="7" className="d-flex flex-column justify-content-end">
                        <h1 className='fw_900 txt-45px'><T>Done! You're now ready!</T></h1>
                        <h5 className='fw_900'><T>Upgrade to make your challenges even more realistic, enganging and educational.</T></h5>
                        <p className='premium_banner_lead txt-16px'><T>You decide how many people to invite - and your invitation can be used again and again for new games, as long as you are Premium.</T></p>
                    </Col>
                    <Col sm="2 premium-img">
                        <img width="239" height="239" src='https://static.aktiedysten.dk/gfx/Om-1-300x300.png' alt="Hand holding a trophy" />
                    </Col>
                </Row>
            </Col>
            </Container>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumHeader.js